import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { z } from "zod";
import { InboxResponse, type LeadSource } from "@avestate/shared";
import { apiFetch } from "@/lib/api.js";
import { useAuth } from "@/auth/useAuth.js";

export type InboxFilters = { source?: string; stage?: string; q?: string; listing_id?: string; page?: number; page_size?: number };

export function useInbox(filters: InboxFilters = {}) {
  const { session } = useAuth();
  const token = session?.access_token;
  return useQuery({
    queryKey: ["inbox", filters],
    enabled: !!token,
    queryFn: () => apiFetch("/api/v1/admin/leads/inbox", token!, InboxResponse, { query: filters }),
  });
}

const PatchAck = z.object({ source: z.string(), id: z.string(), status: z.string() });

export function usePatchLead() {
  const qc = useQueryClient();
  const { session } = useAuth();
  const token = session?.access_token;
  return useMutation({
    mutationFn: ({ source, id, status }: { source: LeadSource; id: string; status: string }) => {
      if (!token) throw new Error("not authenticated");
      return apiFetch(`/api/v1/admin/leads/${source}/${id}`, token, PatchAck, { method: "PATCH", body: { status } });
    },
    onSuccess: () => { void qc.invalidateQueries({ queryKey: ["inbox"] }); },
  });
}
